import React from "react";
import MoodBadIcon from '@material-ui/icons/MoodBad';
import SentimentSatisfiedIcon from '@material-ui/icons/SentimentSatisfied';
import MoodIcon from '@material-ui/icons/Mood';
import { getNPSColor } from "@icarius-utils/colors";
import { getLocalizedString } from "@icarius-localization/strings";

const useNpsData = (data) => {

    const COUNT_GOOD_MIN_VALUE = 9;
    const COUNT_BAD_MAX_VALUE = 6;

    const getPercentage = (amount) => (amount / data.length * 100).toFixed(0);
    const getNPSIcon = (index) => {
        if (index > 7) return <MoodIcon style={{ fill: getNPSColor(index + 1) }} />;
        if (index > 5) return <SentimentSatisfiedIcon style={{ fill: getNPSColor(index + 1) }} />;
        return <MoodBadIcon style={{ fill: getNPSColor(index + 1) }} />;
    };

    const npsAnswersCount = {
        bad: data.filter(item => Number(item.RESPUESTA) <= COUNT_BAD_MAX_VALUE)?.length || 0,
        neutral: data.filter(item => Number(item.RESPUESTA) > COUNT_BAD_MAX_VALUE && Number(item.RESPUESTA) < COUNT_GOOD_MIN_VALUE)?.length || 0,
        good: data.filter(item => Number(item.RESPUESTA) >= COUNT_GOOD_MIN_VALUE)?.length || 0,
    }

    const npsAnswersPercentage = {
        bad: getPercentage(npsAnswersCount.bad),
        neutral: getPercentage(npsAnswersCount.neutral),
        good: getPercentage(npsAnswersCount.good),
    }

    const npsVotesData = [
        {
            title: getLocalizedString("detractors"),
            percentage: npsAnswersPercentage.bad,
            count: npsAnswersCount.bad,
            color: "var(--ownRed)",
        },
        {
            title: getLocalizedString("neutrals"),
            percentage: npsAnswersPercentage.neutral,
            count: npsAnswersCount.neutral,
            color: "var(--ownYellow)",
        },
        {
            title: getLocalizedString("promoters"),
            percentage: npsAnswersPercentage.good,
            count: npsAnswersCount.good,
            color: "var(--ownGreen)",
        },
        {
            title: getLocalizedString("total"),
            count: data.length,
        }
    ];

    const npsValue = npsAnswersPercentage.good - npsAnswersPercentage.bad;

    const npsResultData = [
        {
            title: getLocalizedString("criticalNPS"),
            color: "var(--ownRed)",
            sectionTitle: getLocalizedString("npsRange1"),
        },
        {
            title: getLocalizedString("goodNPS"),
            color: "var(--ownYellow)",
            sectionTitle: getLocalizedString("npsRange2"),
        },
        {
            title: getLocalizedString("npsVeryGood"),
            color: "var(--ownBlue)",
            sectionTitle: getLocalizedString("npsRange3"),
        },
        {
            title: getLocalizedString("npsExcellent"),
            color: "var(--ownGreen)",
            sectionTitle: getLocalizedString("npsRange4"),
        },
    ];

    const npsResultDataItem = (() => {
        if (npsValue >= 75) return npsResultData[3];
        if (npsValue >= 50) return npsResultData[2];
        if (npsValue >= 0) return npsResultData[1];
        return npsResultData[0];
    })();

    const getOptionData = (option) => {
        return ({
            votes: data.filter(item => Number(item.RESPUESTA) === option + 1).length || 0,
            icon: getNPSIcon(option),
        })
    };

    return {
        npsValue,
        npsVotesData,
        npsResultData,
        npsResultDataItem,
        getOptionData,
    }
}

export default useNpsData;
